import { ContextApi } from 'contexts/Localization/types'
import { PageMeta } from './types'

export const DEFAULT_META: PageMeta = {
  title: 'Axd - (BSC)',
  description: 'Earn AXD  through yield farming ',
  image: 'https://axiomadex.com/images/swapimg/twitter.png',
}

export const getCustomMeta = (path: string, t: ContextApi['t']): PageMeta => {
  switch (path) {
    case '/':
      return {
        title: `${t('Home')} | ${t('AxdDex')}`,
      }
    case '/competition':
      return {
        title: `${t('Trading Battle')} | ${t('AxdDex')}`,
      }
    case '/prediction':
      return {
        title: `${t('Prediction')} | ${t('AxdDex')}`,
      }
    case '/farms':
      return {
        title: `${t('Farms')} | ${t('AxdDex')}`,
      }
    case '/pools':
      return {
        title: `${t('Pools')} | ${t('AxdDex')}`,
      }
    case '/lottery':
      return {
        title: `${t('Lottery')} | ${t('AxdDex')}`,
      }
    case '/collectibles':
      return {
        title: `${t('Collectibles')} | ${t('AxdDex')}`,
      }
    case '/ifo':
      return {
        title: `${t('Initial Farm Offering')} | ${t('AxdDex')}`,
      }
    case '/teams':
      return {
        title: `${t('Leaderboard')} | ${t('AxdDex')}`,
      }
    case '/profile/tasks':
      return {
        title: `${t('Task Center')} | ${t('AxdDex')}`,
      }
    case '/profile':
      return {
        title: `${t('Your Profile')} | ${t('AxdDex')}`,
      }
    default:
      return null
  }
}
